<div class="container">
  <h1 class="header">
    <div class="title">オペレーターマッピング</div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <app-bluebean-operator-mapping></app-bluebean-operator-mapping>
</div>
